import { UseFormValues } from "@formiz/core/dist/types/form.types";
import { Button, ButtonColorVariant, ButtonSize, ButtonVariant, IconVariants, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { Accordion, AccordionItem } from "@nextui-org/react";
import { Key } from "@react-types/shared";
import React, { useState } from "react";

import Trans from "@/components/Trans/Trans";

interface IAdvancedSettingsProps {
  setShowDeleteConfirmationDialog: (show: boolean) => void;
  isLoadingDelete: boolean;
  profileForm: UseFormValues;
}

export const AdvancedSettings = ({ setShowDeleteConfirmationDialog, isLoadingDelete }: IAdvancedSettingsProps) => {
  const [selectedKeys, setSelectedKeys] = useState<Key[]>([]);

  const toggleAccordion = () => {
    setSelectedKeys((prev: Key[]) => (prev.includes("advanced") ? [] : ["advanced"]));
  };
  return (
    <Accordion className="px-0 !py-[13px]" selectedKeys={selectedKeys} keepContentMounted>
      <AccordionItem
        key="advanced"
        as="div"
        hideIndicator
        classNames={{
          content: "pt-lg pb-0",
        }}
        HeadingComponent={() => (
          <Button
            variant={ButtonVariant.OUTLINED}
            size={ButtonSize.MEDIUM}
            onClick={toggleAccordion}
            iconEnd={selectedKeys?.includes("advanced") ? IconVariants.CHEVRON_UP : IconVariants.CHEVRON_DOWN}
          >
            <Trans i18nKey="user:profile.advanced.title" />
          </Button>
        )}
      >
        <div className="flex flex-col gap-lg">
          <div className="flex flex-row items-center gap-md py-md">
            <div className="flex flex-col gap-[2px] flex-1">
              <Text variant={TextVariants.LABEL_LARGE_REGULAR}>
                <Trans i18nKey="user:profile.advanced.removeAccount.title" />
              </Text>
              <Text variant={TextVariants.LABEL_SMALL_REGULAR} className={"text-gray-11"}>
                <Trans i18nKey="user:profile.advanced.removeAccount.description" />
              </Text>
            </div>
            <div>
              <Button
                color={ButtonColorVariant.ERROR}
                size={ButtonSize.LARGE}
                onClick={() => setShowDeleteConfirmationDialog(true)}
                disabled={isLoadingDelete}
              >
                <Trans i18nKey="common:remove" />
              </Button>
            </div>
          </div>
        </div>
      </AccordionItem>
    </Accordion>
  );
};
